// extracted by mini-css-extract-plugin
export var bodyStyle = "layout-module--bodyStyle--6de16";
export var bottom = "layout-module--bottom--943eb";
export var contentContainer = "layout-module--contentContainer--95c73";
export var footer = "layout-module--footer--9aadf";
export var imgSplash = "layout-module--imgSplash--19816";
export var logoSplash = "layout-module--logoSplash--f9d25";
export var navLink = "layout-module--nav-link--91590";
export var navbar = "layout-module--navbar--35ca7";
export var navbarCollapse = "layout-module--navbar-collapse--40378";
export var navbarHeader = "layout-module--navbar-header--c3863";
export var textSplash = "layout-module--textSplash--61ed8";
export var titles = "layout-module--titles--9e18a";